/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  // Options.jsx
  items_per_page: '/ à¤ªà¥à¤·à¥à¤ ',
  jump_to: 'à¤à¤¸ à¤ªà¤° à¤à¤²à¥à¤',
  jump_to_confirm: 'à¤ªà¥à¤·à¥à¤à¤¿ à¤à¤°à¥à¤',
  page: '',

  // Pagination.jsx
  prev_page: 'à¤ªà¤¿à¤à¤²à¤¾ à¤ªà¥à¤·à¥à¤ ',
  next_page: 'à¤à¤à¤²à¤¾ à¤ªà¥à¤·à¥à¤ ',
  prev_5: 'à¤ªà¤¿à¤à¤²à¥ 5 à¤ªà¥à¤·à¥à¤ ',
  next_5: 'à¤à¤à¤²à¥ 5 à¤ªà¥à¤·à¥à¤ ',
  prev_3: 'à¤ªà¤¿à¤à¤²à¥ 3 à¤ªà¥à¤·à¥à¤ ',
  next_3: 'à¤à¤à¤²à¥ 3 à¤ªà¥à¤'
};
